import React, { useMemo } from 'react';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, Typography, useMediaQuery, useTheme } from '@material-ui/core';

import Logo from '$app-web/modules/auth/components/logo';
import { getIsACT } from '$app-web/utils';

import useStyles from './styles';

const FormWrapper = (props) => {
    const { role, children } = props;

    const { t } = useTranslation();
    const classes = useStyles();
    const theme = useTheme();
    const isACT = useMemo(() => getIsACT(), []);

    const isSizeXsAndBelow = useMediaQuery(theme.breakpoints.down('xs'));
    const isResearcher = role === 'researcher';

    const description = useMemo(() => {
        if (isResearcher) {
            return t('pdash:sign_up_researcher_description');
        }
        return isACT ? 'Welcome to the ACT Maternity Experience Survey' : t('pdash:sign_up_participant_description');
    }, [isACT, isResearcher, t]);

    return (
        <Grid
            item
            xs
            container
            className={classes.root}
            /* eslint-disable-next-line no-nested-ternary */
            direction={isSizeXsAndBelow ? 'column-reverse' : isResearcher ? 'row-reverse' : 'row'}
        >
            <Grid item xs container alignContent="center" className={classes.formWrapper}>
                {children}
            </Grid>
            <Grid
                item
                container
                direction="column"
                className={clsx(classes.sideBarWrapper, {
                    [classes.actHealthColor]: isACT,
                })}
            >
                <Grid item>
                    <Logo color="white" />
                </Grid>
                <Grid item className={classes.youAreWrapper}>
                    <Typography variant="body2">{t('pdash:sign_up_you_are')}</Typography>
                    <Typography variant="h4">
                        {isResearcher ? t('pdash:signup_role_researcher') : t('pdash:signup_role_participant')}
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography variant="body2">{description}</Typography>
                </Grid>
            </Grid>
        </Grid>
    );
};

FormWrapper.propTypes = {
    role: PropTypes.oneOf(['participant', 'researcher']).isRequired,
    children: PropTypes.node.isRequired,
};

export default FormWrapper;
